module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerHairline.68210a35.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerHairline.otf
// module id = 1064
// module chunks = 0